/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_PORTAL_GROUPS } from './resourceTypeServicedeskPortalGroups.constants.tsx';

const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const servicedeskPortalGroupsResource: RouteResource<any> = createResource<any>({
	type: RESOURCE_TYPE_SERVICEDESK_PORTAL_GROUPS,
	getKey: ({ match: { params } }) => params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-portal-groups", jiraSpaEntry: "async-resource-servicedesk-portal-groups" */ './getData.tsx'
		),
	maxAge: ONE_DAY_IN_MILLIS,
});
